export function buildListingPageLink(pageLink, tagValue) {
    return `${pageLink}?categories=${tagValue}&page=1`;
}
export function isTagsEmpty(props) {
    return !props || !props.tags.length;
}
